// ©2024 Austin App House. All rights reserved.
import axios from 'axios';
import Notification from '../../../components/notification';

const getTeam = async (teamId) => {
    console.log(teamId, 4545)
  try {
    const response = await axios.get(`/api/teams/${teamId}`);
    return response.data?.team || {};
  } catch (error) {
    Notification('error', {
      message: error.response?.data?.message || error.message,
    });
      console.log(error.response?.data?.message)
    return {};
  }
};

export default getTeam;
